<div class="centered">
    <div data-test-id="errorPageContent" class="centered__content">
        <img data-test-id="warningImage" src="./assets/warning.svg" width="70px" height="70px" alt="warn">
        <p data-test-id="title" class="centered__content--error__title" >{{error.title}}</p>
        <p data-test-id="description" class="centered__content--error__description">
            <span>{{ error.description }}</span>
            <a data-test-id="contactPageUrl" [href]="'https://onboardqi.com/#/contact/' + i18nService.selectedLocaleId" i18n="Contact Us|Label for Contact us in case user need assisstance@@appContactUsInErrorPage">Contact us</a>
            for help.
        </p>
        <button data-test-id="navigateActionButton" mat-flat-button color="primary" (click)="navigateToHomeOrLogin(error.login)" >{{ error.login ? TRY_TO_LOGIN_MESSAGE_LOCALIZED : RETURN_TO_HOME_PAGE_MESSAGE_LOCALIZED}}</button>
    </div>
</div>
